import { render, staticRenderFns } from "./summation_method.vue?vue&type=template&id=e452ba0e"
import script from "./summation_method.vue?vue&type=script&lang=js"
export * from "./summation_method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports